import { useEffect, useState } from "react"
import { Veriff } from '@veriff/js-sdk';

function Verify(){
    const [user, setUser] = useState(
        {
          "status": true,
          "message": "Login successful!",
          "data": {
              "rating": "0",
              "availability": "offline",
              "status": true,
              "role": "artisan",
              "_id": "6303b359ae52850016ba2d95",
              "phone": "9135403118",
              "country_code": "234",
              "id": "6303b359ae52850016ba2d95",
              "token": "UEC2EAmYK3h31ssVRWLD8MQjQOapqo",
              "createdAt": "2022-08-22T16:48:25.655Z",
              "updatedAt": "2022-09-01T23:51:54.155Z",
              "__v": 0,
              "address_str": "10 Juliest ultimate Drive",
              "avatar": "avatar",
              "email": "omonicksonowoeye@gmail.com",
              "first_name": "Omoniyi",
              "last_name": "Omoniyi",
              "location": {
                  "type": "Point",
                  "coordinates": [
                      7.471104,
                      9.0570752
                  ],
                  "_id": "6311442da0ebe3001607e006"
              },
              "password": "bml5aW5peWk=",
              "username": "worldest",
              "video": "avatar"
          }
        }
      );
    useEffect(() => {
        const getUser = localStorage.getItem("user");
        setUser(JSON.parse(getUser));
        const verify = Veriff({
            host: 'https://stationapi.veriff.com',
            apiKey: '7b59ebfc-4b80-46ab-ad01-cdb5bc95b1ad',
            parentId: 'veriff-root',
            onSession: (err, response) => {
                // window.veriffSDK.createVeriffFrame({ url: response.verification.url });
                window.open(response.verification.url, '_blank');
                console.log(response);
            }
        });
        verify.setParams({
            
            vendorData: user.data.id
        });
        verify.mount({
            submitBtnText: 'Start Verification'
        });
    }, [])
    return(
        <center>
            <div id='veriff-root'>
                <></>
            </div>
        </center>
    )
}

export default Verify